<template>
  <div class="data-vis" id="wrapper-box">
    <HeaderDataVis />
    <transition name="fade-custom">
      <DataVisContent />
    </transition>
  </div>
</template>

<script>
import HeaderDataVis from "./HeaderDataVis";
import DataVisContent from "./DataVisContent";
export default {
  name: "DataVis",
  components: {
    DataVisContent,
    HeaderDataVis
  },
  computed: {
    getSelectedRCO() {
      return this.$store.getters.getSelectedRCO;
    }
  },
  mounted: function() {
    this.$store.commit("setBackground", "default");
    this.$store.commit("toggleWaves", false);
    this.$store.commit("toggleExpand", true);
  }
};
</script>

<style scoped></style>
